//信息类相关接口
import Http from '../Core/Http';
export default class News extends Http {
  constructor(config) {
    super(config);
  }

  //获取医院介绍
  GetHospitalProfile() {
    return this._get('/api/HospitalProfile/GetHospitalProfile');
  }

  //获取科室列表
  GetDepartmentList() {
    return this._get('/api/HospitalProfile/GetDepartmentList');
  }

  //科室详情/api/HospitalProfile/GetNursingTeamDetial
  GetDepartmentDetial(id) {
    return this._get('/api/HospitalProfile/GetDepartmentDetial', {
      departmentId: id
    });
  }

  //获取就诊指南分类
  GetPatientsGuideCategory() {
    return this._get('/api/HospitalProfile/GetPatientsGuideCategory');
  }

  //获取就诊指南
  GetAllPatientsGuide(id) {
    return this._get('/api/HospitalProfile/GetAllPatientsGuide', {
      articleCategoryId: id
    });
  }

  //获取专家列表
  GetDoctorList() {
    return this._get('/api/HospitalProfile/GetDoctorList');
  }

  //专家详情/api/HospitalProfile / GetDoctorDetial
  GetDoctorDetial(id) {
    return this._get('/api/HospitalProfile/GetDoctorDetial', {
      doctorId: id
    });
  }

  //获取价格公示/api/HospitalProfile/GetMedicineList
  GetMedicineList(data) {
    return this._post('/api/HospitalProfile/GetMedicineList', null, data);
  }

  //获取治疗费用列表/api/HospitalProfile/GetTreatmentFeeList
  GetTreatmentFeeList(data) {
    return this._post('/api/HospitalProfile/GetTreatmentFeeList', null, data);
  }

}



// WEBPACK FOOTER //
// ./src/lib/PMA/News.js